export const PLAYOFF_STAGES = ['Qualifier 1', 'Eliminator', 'Qualifier 2', 'Final'];

const STAGE_META = {
  'Qualifier 1': { key: 'q1', label: 'Qualifier 1' },
  'Eliminator':  { key: 'eliminator', label: 'Eliminator' },
  'Qualifier 2': { key: 'q2', label: 'Qualifier 2' },
  'Final':       { key: 'final', label: 'Final' },
};

export const isPlayoff = (stage) => PLAYOFF_STAGES.includes(stage);

export const stageMeta = (stage) => STAGE_META[stage] || null;
